import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

const ST = { NOUVELLE: "Nouvelle (jamais acceptée)", ACCEPTEE: "Acceptée (non commencée)", EN_PREPARATION: "En préparation", PRETE: "Prête" };

// Clôture de table : confirmation de l'état réel de chaque commande non terminée (servie → stock consommé ; annulée → réservation libérée).
export function CloseConfirmDialog({ target, onConfirm, onClose, busy }) {
  const [dec, setDec] = useState(() => Object.fromEntries((target?.orders || []).map((o) => [o.id, o.suggested])));
  if (!target) return null;
  const orders = target.orders || [];
  return (
    <Dialog open onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent data-testid="close-confirm-dialog" className="max-w-md rounded-3xl bg-[#0C1713] border-[#1B3028] text-stone-100">
        <DialogTitle className="font-serif-display text-xl flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-[#C69C4A]" /> Table {target.num} · commandes non terminées</DialogTitle>
        <DialogDescription className="text-stone-400 text-xs">Confirmez l'état réel de chaque commande. « Servie » déduit les ingrédients (une seule fois) ; « Annulée » libère la réservation sans rien consommer.</DialogDescription>
        <div className="space-y-2 max-h-[50vh] overflow-y-auto pr-1">
          {orders.map((o) => (
            <div key={o.id} data-testid={`close-order-${o.id}`} className="rounded-2xl bg-[#111F1A] border border-[#1B3028] p-3">
              <div className="flex items-center justify-between gap-2">
                <p className="text-sm font-semibold">{o.order_code || o.order_number} <span className="text-xs text-stone-400 font-normal">· {ST[o.status] || o.status}</span></p>
                {o.needs_confirmation && <span className="text-[10px] uppercase font-bold text-amber-300">à vérifier</span>}
              </div>
              <p className="text-xs text-stone-400 truncate mt-0.5">{o.items.map((it) => `${it.quantity}× ${it.name}`).join(", ")}</p>
              <div className="flex gap-2 mt-2">
                {[["served", "Servie / préparée"], ["cancelled", "Annulée / non préparée"]].map(([v, label]) => (
                  <button key={v} data-testid={`close-decision-${o.id}-${v}`} onClick={() => setDec((d) => ({ ...d, [o.id]: v }))}
                    className={`flex-1 h-9 rounded-xl text-xs font-bold border transition-colors ${dec[o.id] === v ? (v === "served" ? "bg-emerald-600 border-emerald-500 text-white" : "bg-red-600/80 border-red-500 text-white") : "border-[#1B3028] text-stone-300 hover:border-[#C69C4A]/50"}`}>{label}</button>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={onClose} disabled={busy} className="flex-1 rounded-full border-[#1B3028] text-stone-200 bg-transparent">Retour</Button>
          <Button data-testid="close-confirm-submit" onClick={() => onConfirm(dec)} disabled={busy} className="flex-1 rounded-full bg-[#C69C4A] hover:bg-[#B38B3A] text-[#0C1713] font-bold">{busy ? "Clôture…" : "Confirmer et clôturer"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
